import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { uuidResponseSchema } from '../types';

export type DepositWalletMutationParams = {
	accountId: number;
	currency: string;
	amount: number;
};

export const createDepositWalletMutation = () =>
	createAuthMutation({
		params: declareParams<DepositWalletMutationParams>(),
		request: {
			method: 'POST',
			url: '/account/replenish',
			body: (data) => data,
		},
		response: {
			contract: zodContract(uuidResponseSchema),
		},
	});
